<template>
    <div class="list">
        <manage-title>知识点</manage-title>
        <div class="content">
            <div class="top">
                <el-button
                    v-if="$store.state.isCheckEnd"
                    icon="el-icon-circle-plus"
                    type="primary"
                    plain
                    size="small"
                    @click="Add"
                >
                    添加
                </el-button>
            </div>

            <div class="table">
                <el-table
                    ref="tableSort"
                    v-loading="listLoading"
                    :element-loading-text="loadingText"
                    :highlight-current-row="true"
                    :data="data"
                    row-key="Id"
                    :tree-props="{
                        children: 'children',
                        hasChildren: 'hasChildren'
                    }"
                >
                    <el-table-column
                        prop="KnowledgePointName"
                        label="名称"
                        align="left"
                        :tree-props="{
                            children: 'children',
                            hasChildren: 'hasChildren'
                        }"
                    ></el-table-column>

                    <el-table-column
                        prop="Remark"
                        label="备注"
                        align="left"
                    ></el-table-column>

                    <el-table-column
                        prop="RankNum"
                        label="排序"
                        align="center"
                        width="200"
                    ></el-table-column>

                    <el-table-column label="操作" width="200px" align="center">
                        <template #default="{ row }">
                            <el-tag
                                v-if="$store.state.isCheckEnd"
                                size="small"
                                type="success"
                                class="table-btn"
                                @click="Edit(row)"
                            >
                                编辑
                            </el-tag>
                            <el-tag
                                size="small"
                                type="danger"
                                class="table-btn"
                                @click="Delete(row)"
                            >
                                删除
                            </el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!--（新增、编辑）弹框-->
            <div>
                <el-dialog
                    :destroy-on-close="true"
                    :close-on-click-modal="false"
                    width="550px"
                    :title="dialogTitle"
                    :visible.sync="dialogVisible"
                    custom-class="m-dialog"
                    :lock-scroll="false"
                    @close="CloseDialog"
                >
                    <el-form
                        ref="pointForm"
                        :rules="rules"
                        :model="pointForm"
                        size="medium"
                        label-width="120px"
                    >
                        <el-form-item label="名称" prop="KnowledgePointName">
                            <el-input
                                v-model="pointForm.KnowledgePointName"
                                class="dialog-text"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="父级知识点">
                            <el-cascader
                                v-model.number="pointForm.ParentId"
                                :options="data"
                                :props="{
                                    checkStrictly: true,
                                    value: 'Id',
                                    label: 'KnowledgePointName'
                                }"
                                clearable
                                class="dialog-text"
                                placeholder="请输入关键字检索..."
                                @change="GetParentId"
                            ></el-cascader>
                        </el-form-item>

                        <el-form-item label="备注">
                            <el-input
                                v-model="pointForm.Remark"
                                class="dialog-text"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="排序">
                            <el-input
                                v-model.number="pointForm.RankNum"
                                class="dialog-text"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="CloseDialog" size="small"
                            >取 消</el-button
                        >
                        <el-button
                            type="primary"
                            @click="Save('pointForm')"
                            size="small"
                            >确 定</el-button
                        >
                    </div>
                </el-dialog>
            </div>
            <!--（新增、编辑）弹框-->
        </div>
    </div>
</template>

<script>
import {
    GetOrganPointInfo,
    SaveOrganPoint,
    DeleteOrganPoint
} from "@/api/category";
import ManageTitle from "@/components/manager/ManageTitle";

export default {
    components: { ManageTitle },
    data() {
        return {
            background: true,
            loadingText: "正在加载...",
            listLoading: false,
            data: [],
            // 弹框标题
            dialogTitle: "",
            dialogVisible: false,
            // 知识点表单
            pointForm: {
                Id: 0,
                ParentId: null,
                KnowledgePointName: "",
                RankNum: null,
                Remark: ""
            },
            rules: {
                KnowledgePointName: [
                    {
                        required: true,
                        message: "请填写用户组名称",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    created() {
        this.GetOrganPointInfo();
    },
    methods: {
        // 获取机构知识点信息
        async GetOrganPointInfo() {
            try {
                const { data } = await GetOrganPointInfo();
                this.data = data.data;
                // this.data.splice(0, 0, { KnowledgePointName: "无", id: "0" })
            } catch (err) {
                this.$toast("获取失败");
            }
        },
        // 打开新增弹框
        Add() {
            this.dialogTitle = "新增知识点";
            this.dialogVisible = true;
        },
        // 打开编辑弹框
        Edit(row) {
            this.dialogTitle = "编辑知识点";

            this.pointForm = {
                Id: row.Id,
                ParentId: row.ParentId,
                KnowledgePointName: row.KnowledgePointName,
                RankNum: row.RankNum,
                Remark: row.Remark
            };

            this.dialogVisible = true;
        },
        // 保存知识点
        async Save(formName) {
            var result = false;
            this.$refs[formName].validate((valid) => {
                result = valid;
            });

            if (result) {
                try {
                    const { data } = await SaveOrganPoint(this.pointForm);

                    if (data.code === 100) {
                        this.$message({
                            message: "保存成功！",
                            type: "success"
                        });
                        this.GetOrganPointInfo();
                        this.CloseDialog();
                    } else {
                        this.$message({ message: data.msg, type: "error" });
                    }
                } catch (err) {
                    this.$message({ message: "服务器开小差了", type: "error" });
                }
            }
        },
        // 删除
        Delete(row) {
            try {
                this.$confirm(
                    "确认删除知识点：" + row.KnowledgePointName + "?",
                    "提示",
                    {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                        lockScroll: false
                    }
                )
                    .then(() => {
                        this.DeletePoint(row.Id);
                    })
                    .catch(() => {});
            } catch (err) {
                this.$message({ message: "服务器开小差了！", type: "success" });
            }
        },
        // 删除知识点
        async DeletePoint(id) {
            try {
                const { data } = await DeleteOrganPoint({
                    Id: id
                });
                if (data.code === 100) {
                    this.$message({ message: data.msg, type: "success" });
                    this.GetOrganPointInfo();
                } else {
                    this.$message({ message: data.msg, type: "error" });
                }
            } catch (err) {
                this.$message({ message: "删除发生异常！", type: "error" });
            }
        },
        // 下拉框选择父级Id
        GetParentId(value) {
            this.pointForm.ParentId = value[value.length - 1];
        },
        // 关闭弹框
        CloseDialog() {
            this.dialogVisible = false;
            this.pointForm = {
                Id: 0,
                ParentId: null,
                KnowledgePointName: "",
                RankNum: null,
                Remark: ""
            };
        }
    }
};
</script>

<style lang="less" scoped>

.list {
    min-height: 700px;
    width: 100%;
    background: white;
    border-radius: 16px;
    margin: 0 auto;
    margin-bottom: 30px;
}

.tit {
    padding: 20px 20px 0px 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e8ec;

    .btns {
        width: 80px;
        height: 35px;
        box-sizing: border-box;
        margin: 0 25px 0 10px;
        cursor: pointer;

        .tab {
            width: 50px;
            height: 4px;
            background: #256cf4;
            border-radius: 2px;
        }
    }
}

.content {
    .top {
        height: 50px;
        line-height: 50px;
        padding-left: 40px;
        padding-top: 20px;
    }

    .table {
        padding: 0 30px;

        .table-btn {
            cursor: pointer;
            margin-left: 5px;
        }
    }

    .dialog-text {
        width: 300px;
    }
}
</style>
